import { Injectable } from "@angular/core";

@Injectable()

export class MobileWatcherService {
    public isMobile: boolean;
    
    constructor() {}

    // LLamar a esta función en OnInit del componente deseado
    public getMobileDevice() {
        this.isMobile = window.innerWidth <= 768 ? true : false;
        return this.isMobile;
    }
}